export const localization = {
  pt: {
    title: 'Criar catálogo',
    subtitle: 'Centralize documentos, links e artigos para que o agente tenha acesso ao conhecimento necessário.',
    input: {
      placeholder: 'Nome do catálogo',
      requiredErrorMessage: 'O nome do catálogo é obrigatório.',
    },
    cancelButton: 'Cancelar',
    saveButton: 'Salvar',
    successToast: {
      title: 'Catálogo criado',
      message: 'O catálogo foi criado e está disponível',
    },
    errorToast: {
      title: 'Falha ao criar catálogo',
      message: 'Não foi possível criar o catálogo. Tente novamente.',
    },
  },
  en: {
    title: 'Create catalog',
    subtitle: 'Centralize documents, links and articles so the agent has access to the necessary knowledge.',
    input: {
      placeholder: 'Catalog name',
      requiredErrorMessage: 'The catalog name is required.',
    },
    cancelButton: 'Cancel',
    saveButton: 'Save',
    successToast: {
      title: 'Catalog created',
      message: 'The catalog has been created and is available',
    },
    errorToast: {
      title: 'Failed to create catalog',
      message: 'Could not create catalog. Please try again.',
    },
  },
  es: {
    title: 'Crear catálogo',
    subtitle: 'Centralice documentos, enlaces y artículos para que el agente tenga acceso al conocimiento necesario.',
    input: {
      placeholder: 'Nombre del catálogo',
      requiredErrorMessage: 'El nombre del catálogo es obligatorio.',
    },
    cancelButton: 'Cancelar',
    saveButton: 'Guardar',
    successToast: {
      title: 'Catálogo creado',
      message: 'El catálogo ha sido creado y está disponible',
    },
    errorToast: {
      title: 'Error al crear el catálogo',
      message: 'No se pudo crear el catálogo. Por favor, inténtelo de nuevo.',
    },
  },
};
